import React from "react";

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const StopIcon: React.FC<IconProps> = ({ width = 20, height = 20, className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="6" y="6" width="12" height="12" rx="2" />
  </svg>
);
